// src/hooks/useForm.js
import { useState } from 'react';

const useForm = (initialData, validationRules = {}) => {
  const [formData, setFormData] = useState(initialData);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    
    Object.keys(validationRules).forEach(field => {
      const rule = validationRules[field];
      const value = formData[field];
      
      if (rule.required && (!value || value.trim() === '')) {
        newErrors[field] = rule.message || `${field} is required`;
      } else if (rule.pattern && value && !rule.pattern.test(value)) {
        newErrors[field] = rule.message || `${field} is invalid`;
      } else if (rule.custom && value) {
        const customError = rule.custom(value, formData);
        if (customError) {
          newErrors[field] = customError;
        }
      }
    });
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const reset = () => {
    setFormData(initialData);
    setErrors({});
  };

  return { 
    formData, 
    errors, 
    handleChange, 
    validate, 
    reset, 
    setFormData  // Make sure this is included in the return
  };
};

export default useForm;